import {
  CHANGE_MEDPASS_LIST,
  CHANGE_MEDPASS_POPUP_VISIBILITY,
  CHANGE_SUB_MEDPASS_POPUP_VISIBILITY,
  CHANGE_SUBSCRIPTION_POPUP_VISIBILITY,
} from './types';
import {message} from 'antd';
import {client} from '../../apollo/apolloClient';
import {GET_MEDPASS_LIST, VERIFY_PAYMENTS} from '../../apollo/schema';
import {getWalletData} from './Util';

export const getMedPassList = () => {
  return async (dispatch) => {
    client.query({
      query: GET_MEDPASS_LIST,
    }).then(response => {
      if (response.errors && response.errors.length > 0) {
        message.error('Something went wrong while fetching passes');
      } else {
        const passesList = response.data.medpassList || [];
        let data = {
          // Combo pass list
          '1': [],
          // Video pass list
          '2': [],
          // Test pass list
          '3': [],
        };
        passesList.forEach(pass => {
          const {subscriptionModel} = pass;
          switch (subscriptionModel) {
            case 1:
              data['1'].push(pass);
              break;
            case 2:
              data['2'].push(pass);
              break;
            case 3:
              data['3'].push(pass);
              break;
            default:
              break;
          }
        });
        dispatch({
          type: CHANGE_MEDPASS_LIST,
          payload: data,
        });
      }
    }).catch(() => message.error('Something went wrong while fetching passes'));
  };
};

export function showHideSubscriptionPopup(visible) {
  return {
    type: CHANGE_SUBSCRIPTION_POPUP_VISIBILITY,
    payload: visible,
  };
}

export function paymentHandler(order_id, id, medpassPage) {
  return async (dispatch, getState) => {
    const {userData: {email, name}} = getState().util;
    let options = {
      'key': process.env.NODE_ENV === 'production' ?
          'rzp_live_xSYPLyb1a0PXkV' :
          'rzp_test_Rey6noSPoaD37a',
      'name': 'MedCampus',
      'description': 'Medical Exam Training',
      'image': 'https://assets-new.medcampus.io/assets/images/medcampus-icon.jpg',
      'handler': function(response) {
        client.query({
          query: VERIFY_PAYMENTS,
          variables: {
            orderId: response.razorpay_order_id,
            paymentId: response.razorpay_payment_id,
            signature: response.razorpay_signature,
          },
        }).then(() => {
          medpassPage ?
              Promise.all(
                  [
                    dispatch({
                      type: CHANGE_SUB_MEDPASS_POPUP_VISIBILITY,
                      payload: true,
                    }),
                    getWalletData(),
                  ],
              ) : Promise.all(
              [
                dispatch({
                  type: CHANGE_MEDPASS_POPUP_VISIBILITY,
                  payload: true,
                }),
                getWalletData(),
              ],
              );
        }).catch(() => {
          medpassPage ? dispatch({
                type: CHANGE_SUB_MEDPASS_POPUP_VISIBILITY,
                payload: false,
              }) :
              dispatch({
                type: CHANGE_MEDPASS_POPUP_VISIBILITY,
                payload: false,
              });
          message.warning('Something went wrong.');
        });
      },
      'order_id': order_id,
      'prefill': {
        'name': name,
        'email': email,
        'contact': '',//contactNumber,
      },
      'notes': {
        'address': id,
      },
      'theme': {
        'color': 'Blue',
      },

    };
    let rzp = new window.Razorpay(options);
    rzp.open();
  };
}

export function closeMedPassPopup(data) {
  return {
    type: CHANGE_MEDPASS_POPUP_VISIBILITY,
    payload: data,
  };
}

export function closeSubMedPassPopup(data) {
  return {
    type: CHANGE_SUB_MEDPASS_POPUP_VISIBILITY,
    payload: data,
  };
}
